<template>
	<div class="content">
		<div class="row">
			<div class="col-8">
				<div class="btn-acciones">
					<b-button-toolbar>
						<b-button-group>
							<b-button variant="dark" size="sm" @click="crear('simple')" v-b-tooltip.hover title="Crear Cliente"><i class="fas fa-plus fa-fw" /></b-button>
							<b-button variant="dark" size="sm" @click="crear('masivo')" v-b-tooltip.hover title="Carga Masiva de Clientes"><i class="fas fa-upload fa-fw" /></b-button>
						</b-button-group>
					</b-button-toolbar>
				</div>
				<div class="clientes-info">Clientes <b>{{ Intl.NumberFormat("es-CL").format(totalFiltrados) }} de {{ Intl.NumberFormat("es-CL").format(totalClientes) }}</b></div>
			</div>
			<div class="col-4">
				<b-input size="sm" v-model="filtro" type="search" placeholder="Búsqueda" />
			</div>
		</div>
		<hr style="margin-top: 5px" />
		<div class="data">
			<div class="tabla">
				<b-table striped small hover head-variant="light" :per-page="perPage" :current-page="currentPage" :items="getClientes" :fields="columnas">
					<template #cell(_source.estado)="data">
						<b-form-checkbox switch :checked="data.item._source.estado == 'activo'" />
					</template>
					<template #cell(editar)="data">
						<b-button variant="link" size="sm"><i class="fas fa-edit fa-fw" @click="editar(data.item._id)" v-b-tooltip.hover title="Editar Cliente" /></b-button>
					</template>
				</b-table>
				<b-pagination v-model="currentPage" :total-rows="totalFiltrados" :per-page="perPage"></b-pagination>
			</div>
		</div>
	</div>
</template>
<script lang="ts">

	import axios from "axios"
	import Editar from "./editar.vue"


	export default 
	{
		name: "Listado",
		props: {
			menu: String, // Variable que guarda el menu seleccionado
			onEditar: Function,
			onCrear: Function,
		},
		data() {
			return {
				periodo: "",
				filtro: "",
				perPage: 10,
				currentPage: 1,
				columnas: [
					{ key: "_source.estado", label: "Estado", sortable: false },
					{ key: "editar", label: "Editar", sortable: false },
					{ key: "_source.CLIENT_NAME", label: "Empresa", sortable: true, class: "text-nowrap" },
					{ key: "_source.GRUPO_ECONOMICO", label: "Grupo Económico", sortable: true, class: "text-nowrap" },
					{ key: "_source.CLIENT_TAX_CODE", label: "RUT", sortable: true, class: "text-nowrap" },
					{ key: "_source.DETALLE_CC_FACTURACION", label: "Det. Facturación", sortable: true, class: "text-nowrap" },
					{ key: "_source.CLIENT_ID", label: "Client ID", sortable: true, class: "text-nowrap" },
					{ key: "_source.CLIENT_ID_MADRE", label: "Client ID Madre", sortable: true, class: "text-nowrap" },
				],
				clientes: [],
				cliente: {}, // Cliente seleccionado para editar
				mostrar_editar: false,
			}
		},
		created() {

		},
		mounted: function() {

			const that = this

			window.event.$on("evento-cambio-periodo", function(periodo) {

				that.periodo = periodo
			})

			this.leerDatos()
		},
		computed: {

			// Retorna la lista de proyectos luego de aplicar el filtro ingresao (o si esta en blanco)
			getClientes() {

				return this.filtrar()
			},

			// Cuenta la cantidad de proyectos a mostrar (considera el filtro)
			totalFiltrados() {

				return this.filtrar().length
			},

			totalClientes() {

				return this.clientes.length
			}
		},
		methods: {

			leerDatos() {

				// Ocultamos el panel con los dtos y mostramos la imagen cargando
				window.event.$emit("mostrar-cargando", true)

				// Llamamos al WS para traer las fichas a mostrar
				var request = {
					"usuario": this.$usuario,
					"destino": this.$env,
					"tx": "man0",
					"proceso": "cli2adminlist",
				}

				axios.post("/face", request, { headers: { "Content-Type": "text/plain" } }).then(response => {

					if (response.data.estatus != "OK") {

						this.nodata = true
						this.mensaje = "No hay datos" 
					} else {

						this.nodata = false
						this.mensaje = ""

						for (var cliente of response.data.data)
							this.clientes.push(cliente)
					}

					// Ocultamos la imagen cargando y mostramos el panel con los datos
					window.event.$emit("mostrar-cargando", false)

				}).catch(ex => {

					// Si hubo un error, pasamos por aca
					console.log(ex.message)

					// Ocultamos la imagen cargando y mostramos el panel con los datos
					window.event.$emit("mostrar-cargando", false)
				})
			},

			filtrar() {

				return this.clientes.filter((cliente) => {
					var client_name = cliente._source.CLIENT_NAME != undefined ? cliente._source.CLIENT_NAME : ""
					var grupo_economico = cliente._source.GRUPO_ECONOMICO != undefined ? cliente._source.GRUPO_ECONOMICO : ""
					var client_tax = cliente._source.CLIENT_TAX_CODE != undefined ? cliente._source.CLIENT_TAX_CODE : ""
					var detalle_cc = cliente._source.DETALLE_CC_FACTURACION != undefined ? cliente._source.DETALLE_CC_FACTURACION : ""
					var client_id = cliente._source.CLIENT_ID != undefined ? cliente._source.CLIENT_ID : ""
					var client_id_m = cliente._source.CLIENT_ID_MADRE != undefined ? cliente._source.CLIENT_ID_MADRE : ""

					return client_name.toString().toLowerCase().includes(this.filtro.toLowerCase()) ||
						grupo_economico.toString().toLowerCase().includes(this.filtro.toLowerCase()) ||
						client_tax.toString().toLowerCase().includes(this.filtro.toLowerCase()) ||
						detalle_cc.toString().toLowerCase().includes(this.filtro.toLowerCase()) ||
						client_id.toString().toLowerCase().includes(this.filtro.toLowerCase()) ||
						client_id_m.toString().toLowerCase().includes(this.filtro.toLowerCase())
				})
			},

			editar(id) {

				if (this.onEditar)
					this.onEditar(id)
			},

			crear(tipo) {

				if (this.onCrear)
					this.onCrear(tipo, this.clientes)
			},
		}
	}

</script>
<style scoped>

	.content {
		height: 485px;
		/*margin: 10px;*/
		border: 1px solid lightgray;
		background-color: white;
		padding: 10px 10px 5px 10px;
	}

	.btn-acciones {
		float: left;
		margin-right: 10px;
	}

	.btn-accion {
		float: left;
		margin-right: 3px;
	}

	.clientes-info {
		float: left;
		padding-top: 4px;
	}

	.titulo {
		margin-bottom: 5px;
	}

	.data {
		width: 100%;
		margin-top: 10px;
		height: Calc(100% - 50px);
		overflow: auto;
	}

	.filtro {
		width: 250px;
		padding-bottom: 10px;
	}

	.tabla {
		width: 100%;
		height: auto;
		overflow: auto;
		font-size: 14px;
	}

</style>
